import React from 'react';
import {
    Grid,
    Typography,
    Button,
    Alert,
} from '@mui/material';
import LaunchUrlField from './components/LaunchUrlField';
import useGameFlexUrls from './hooks/useGameFlexUrls';

const GameFlexLaunchComponent = ({ selectedServer, demo, showFrame }) => {
    const {
        error,
        authenticate,
        gameFlexReal,
        gameFlexDemo,
    } = useGameFlexUrls(selectedServer);

    const isMobile = selectedServer?.game?.platform === "HTML5 - Mobile";
    const uglOnly = selectedServer?.market?.uglOnly;

    const openTab = (url) => {
        window.open(url, "_blank");
    };

    const openFrame = (url) => {
        showFrame(url);
    };

    const launchDefaultGameflexTest = () => {
        const gameId = selectedServer?.game?.GameflexGameID || selectedServer.demo;
        const channel = selectedServer?.mobDesk;

        const url = `https://operatorwallet.azurewebsites.net/api/launch?gameid=${gameId}&channel=${channel}`;
        openTab(url);
    };

    if (isMobile && !uglOnly) {
        return (
            <Typography color="error">
                <b>{selectedServer?.game?.gameId}</b> is an H5 Mobile game, please select a{" "}
                <b>Flash/Desktop</b> game or use the Pathfinder tab to continue.
            </Typography>
        );
    }

    if (uglOnly) {
        return (
            <Typography color="error">
                <b>{selectedServer?.market?.name}</b> is a UGL-only Market. Please select the UGL
                tab for your Launch links.
            </Typography>
        );
    }

    return (
        <div>
            {error && (
                <Alert severity={error.includes("Successfully") ? "success" : "error"} style={{ marginBottom: "16px" }}>
                    {error}
                </Alert>
            )}

            <Grid container spacing={3} style={{ marginTop: "16px" }}>
                <Grid item xs={12}>
                    <Typography variant="subtitle1" style={{ marginBottom: "8px" }}>
                        <b>Predefined GameFlex Launch</b> - Predefined lobby settings. No account info required. Control over Game launched.
                    </Typography>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={launchDefaultGameflexTest}
                        style={{ marginBottom: "24px" }}
                    >
                        Launch default GameflexTest
                    </Button>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="subtitle1" style={{ marginBottom: "8px" }}>
                        <b>Custom GameFlex Launch</b> - Full control over all launch parameter fields
                    </Typography>
                    <Button variant="contained" color="primary" onClick={authenticate}>
                        Generate Session Ticket
                    </Button>
                </Grid>

                <Grid item xs={12}>
                    <LaunchUrlField
                        url={gameFlexReal}
                        label="Real - Must generate session ticket to use"
                        helperText="Launch link for live gameplay"
                        onOpenTab={openTab}
                        onOpenFrame={openFrame}
                    />
                </Grid>

                <Grid item xs={12}>
                    <LaunchUrlField
                        url={gameFlexDemo}
                        label="Demo"
                        helperText="Launch link for demo gameplay"
                        onOpenTab={openTab}
                        onOpenFrame={openFrame}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default GameFlexLaunchComponent;